export default __webpack_public_path__ + "static/media/BowlbyOneSC-Regular.841cf9be.ttf";